import reduceReducers from "reduce-reducers";

import { SIDELOADED_BUSINESS } from "constants/actionTypes";

import {
  bulkUpdateCases,
  defaultInitialState,
  offlineCrudReducer,
} from "lib/reducers";
import { deserializeSideLoadedBusiness } from "lib/serializers/sideLoadedBusinesses";

const crudReducer = offlineCrudReducer(SIDELOADED_BUSINESS, {
  deserializer: deserializeSideLoadedBusiness,
});

const initialState = { ...defaultInitialState };

const bulkSetIgnoredReducer = (state = initialState, action) => {
  switch (action.type) {
    // The request carries an entry per record, so the grid reflects the change
    // before the response; the response carries only the records it changed.
    case SIDELOADED_BUSINESS.BULK_SET_IGNORED.REQUEST:
    case SIDELOADED_BUSINESS.BULK_SET_IGNORED.SUCCESS:
      return bulkUpdateCases(
        state,
        action,
        "byId",
        deserializeSideLoadedBusiness,
      );

    case SIDELOADED_BUSINESS.BULK_SET_IGNORED.FAILURE: {
      const { ids, isIgnored } = action;
      return {
        ...state,
        byId: ids.reduce(
          (byId, id) =>
            byId[id]
              ? {
                  ...byId,
                  [id]: { ...byId[id], isIgnored: !isIgnored, syncing: false },
                }
              : byId,
          { ...state.byId },
        ),
      };
    }

    default:
      return state;
  }
};

const sideLoadedBusinesses = reduceReducers(
  initialState,
  crudReducer,
  bulkSetIgnoredReducer,
);

export default sideLoadedBusinesses;
